export default __webpack_public_path__ + "static/media/logo-tagline-new.97a6de96.png";